// English number-to-words helper for currency amounts.
// XOF (West African CFA franc) has no minor unit, so we spell whole francs.
// Falls back gracefully for very large or invalid numbers.

const ONES = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen',
];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
const SCALES = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

function threeDigitsToWords(n) {
  // n is 0..999
  let out = '';
  const hundreds = Math.floor(n / 100);
  const rest = n % 100;
  if (hundreds) out += `${ONES[hundreds]} Hundred`;
  if (rest) {
    if (out) out += ' ';
    if (rest < 20) {
      out += ONES[rest];
    } else {
      const tens = Math.floor(rest / 10);
      const ones = rest % 10;
      out += TENS[tens];
      if (ones) out += `-${ONES[ones]}`;
    }
  }
  return out;
}

function integerToWords(num) {
  if (num === 0) return 'Zero';
  // Split into groups of three digits, from the least significant.
  const groups = [];
  let n = num;
  while (n > 0) {
    groups.push(n % 1000);
    n = Math.floor(n / 1000);
  }
  if (groups.length > SCALES.length) {
    // Too large to name safely — return the numeric string as words fallback.
    return String(num);
  }
  const parts = [];
  for (let i = groups.length - 1; i >= 0; i -= 1) {
    const g = groups[i];
    if (g === 0) continue;
    const words = threeDigitsToWords(g);
    const scale = SCALES[i];
    parts.push(scale ? `${words} ${scale}` : words);
  }
  return parts.join(' ');
}

/**
 * Convert a numeric amount to an English words string, suffixed with the currency label.
 * @param {number|string} value - amount (whole-number francs for XOF)
 * @param {string} currency - currency code (default XOF -> "Francs CFA")
 * @returns {string} e.g. "One Hundred Twenty-Three Thousand Francs CFA Only"
 */
export function amountToWords(value, currency = 'XOF') {
  const num = Math.round(Number(value) || 0);
  if (!Number.isFinite(num) || num < 0) return '';
  const label = currency === 'XOF' ? 'Francs CFA' : currency;
  const words = integerToWords(num);
  return `${words} ${label} Only`;
}

export default amountToWords;
